// removed by extract-text-webpack-plugin
module.exports = {"container":"container-21Xy3","modal":"modal-onVUQ","feedback":"feedback-m-Vki","textarea":"textarea-2MoJT","btn":"btn-37zFV btn-3FsRe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/feedback/style.scss
 ** module id = 203
 ** module chunks = 0
 **/